import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from 'vue';
import { EColumnType } from '@blade-sxp/record-center/interfaces/attendanceRecord';
export default /*#__PURE__*/ _defineComponent({
    __name: 'attendanceTable',
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        columns: {
            type: Array,
            default: () => [],
        },
        pagination: {
            type: Object,
            default: () => {
                return {
                    page: 1,
                    size: 10,
                    sizes: [10, 20, 50, 100, 200],
                    total: 0,
                };
            },
        },
        statusConfig: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['clickColumnBtn', 'changePage'],
    setup(__props, { emit }) {
        const props = __props;
        const curPagination = ref({
            page: 1,
            size: 10,
            sizes: [10, 20, 50, 100, 200],
            total: 0,
        });
        watch(() => props.pagination, (nv) => {
            curPagination.value = nv;
        }, {
            deep: true,
        });
        function computedStatusStyle(status) {
            // const { color = '' } = props.statusConfig?.[status] ?? {};
            const { color = '' } = props.statusConfig?.[status] ?? {};
            return { background: color };
        }
        function computedStatusLabel(status) {
            const { label = '' } = props.statusConfig?.[status] ?? {};
            return label;
        }
        function handleSizeChange(size) {
            curPagination.value.size = size;
            changePagination();
        }
        function handlePageChange(page) {
            curPagination.value.page = page;
            changePagination();
        }
        function changePagination() {
            // curPagination
            emit('changePage', { ...curPagination.value });
        }
        function handleColumnBtn(btnKey, data) {
            emit('clickColumnBtn', { key: btnKey, data });
        }
        return { __sfc: true, props, emit, curPagination, computedStatusStyle, computedStatusLabel, handleSizeChange, handlePageChange, changePagination, handleColumnBtn, EColumnType };
    }
});
